import { render, staticRenderFns } from "./ClinicPatients.vue?vue&type=template&id=77f8a92c"
import script from "./ClinicPatients.vue?vue&type=script&lang=js"
export * from "./ClinicPatients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports